import React from 'react';
import { StrategicRoadmap } from '../components/roadmap/StrategicRoadmap';

export const Roadmap: React.FC = () => {
  return <StrategicRoadmap />;
};